import apiClient from "../common/apiClient.js";

export default class MemberShipController {
  async CreateExcelData(data, token) {
    try {
      return await apiClient.post("/memberExcelData", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }

  async GetGridData(token) {
    try {
      return await apiClient.get("/getMemberShipGrid", {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async CreateMember(data, token) {
    try {
      return await apiClient.post("/createMember", data, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async GetMemberById(id, token) {
    try {
      return await apiClient.get("/getmemberById/" + id, {
        headers: { Authorization: `Bearer ${token}` },
      });
    } catch (error) {
      return error;
    }
  }
  async UpdateMember(data, token) {
    try {
      return await apiClient.put("/updateMembersData", data, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async DeleteMemberID(id, token) {
    try {
      return await apiClient.delete("/deleteMember/" + id, {
        headers: {
          Authorization: `Bearer ${token}`,
          "Content-Type": "multipart/form-data",
        },
      });
    } catch (error) {
      return error;
    }
  }
  async GetFamilyName(data, token) {
    try {
      return await apiClient.get("/getMastersFamily/" + data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
  async CreateFamilyName(data, token) {
    try {
      return await apiClient.post("/createFamilyName", data, {
        headers: {
          Authorization: `Bearer ${token}`,
        },
      });
    } catch (error) {
      return error;
    }
  }
}
